/**
 * Central-Time payout-desk hours helpers. Shared by the Cash Out dialog
 * (big amber overlay) and the small header chip so both stay perfectly
 * in sync — one source of truth for the schedule.
 *
 * Payout desk hours: 8 AM – 10 PM CT (America/Chicago), DST-safe via
 * the Intl API.
 */
export const AFTER_HOURS_START_CT = 22;
export const AFTER_HOURS_END_CT = 8;

export const isAfterHoursCT = () => {
    try {
        const h = parseInt(new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Chicago', hour: 'numeric', hour12: false,
        }).format(new Date()), 10);
        return h >= AFTER_HOURS_START_CT || h < AFTER_HOURS_END_CT;
    } catch { return false; }
};

/** Returns e.g. "3h 42m" until 8 AM CT reopens, or '' when open. */
export const timeUntilOpenCT = () => {
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Chicago',
            hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false,
        }).formatToParts(new Date());
        const h = parseInt(parts.find(p => p.type === 'hour')?.value || '0', 10);
        const m = parseInt(parts.find(p => p.type === 'minute')?.value || '0', 10);
        const s = parseInt(parts.find(p => p.type === 'second')?.value || '0', 10);
        const nowMins = h * 60 + m + s / 60;
        const openMins = AFTER_HOURS_END_CT * 60;
        let diff = openMins - nowMins;
        if (diff <= 0) diff += 24 * 60;
        const hh = Math.floor(diff / 60);
        const mm = Math.floor(diff % 60);
        return `${hh}h ${mm.toString().padStart(2, '0')}m`;
    } catch { return ''; }
};
